import React, { useState, useEffect, useContext } from 'react';
import { withRouter, Route, Switch, Redirect } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import GenericListPair from 'modules/common/components/GenericListPair';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import useDebounce from 'modules/common/components/UseDebounce';
import { ModalContext } from 'App';
import PropTypes from 'prop-types';
import * as actions from '../action';
import * as c from '../constant';
import NewBusinessesContent from './NewBusinessesContent';
import BusinessAuditLogs from '../components/BusinessAuditLogs';
import TaxCreditModal from '../modals/TaxCreditModal';
import BusinessModal from '../modals/BusinessModal';
import UpdateVeterinaryModal from '../modals/UpdateVeterinaryModal';
import UpdateBaseLineModal from '../modals/UpdateBaseLineModal';

const form = {
  keyword: '',
};

function NewBusinessesContainer({
  match,
  history,
  getNewBusinessesList,
  newBusinessesList,
  isLoading,
  removeNewBusinesses,
  newBusinessesListPager,
  getSingleNewBusinesses,
  ordinanceRevisionId,
  holdBusiness,

  toggleBusinessRetirement,
}) {
  const [formData, setFormData] = useState(form);
  const [filter, setFilter] = useState(form);
  const setModal = useContext(ModalContext);

  const handleOnChange = e => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleAddModal = e => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: (
        <BusinessModal ordinanceRevisionId={ordinanceRevisionId} type="NEW" />
      ),
      title: 'Add Business',
      modalSize: 'modal-xl',
    });
  };

  const handleAddTaxCredit = data => e => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: (
        <TaxCreditModal
          id={data.id}
          ordinanceRevisionId={ordinanceRevisionId}
          type="NEW"
        />
      ),
      title: 'Add Tax Credit',
      modalSize: 'modal-md',
    });
  };

  const handleEdit = data => e => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: (
        <BusinessModal
          type="EDIT"
          updateList={data.attributes}
          id={data.id}
          newBusinessesInfo={data}
          ordinanceRevisionId={ordinanceRevisionId}
        />
      ),
      title: 'Update Business',
      modalSize: 'modal-xl',
    });
  };

  const handleRemove = data => e => {
    e.preventDefault();
    ConfirmAlert(
      'Are you sure, you want to remove this business?',
      () => {
        removeNewBusinesses(data.id, () => {
          setFormData({
            ...formData,
            keyword: '',
          });
          getNewBusinessesList();
          const id = _.get(newBusinessesList, '1.id');
          history.push(`/bpls/new-business/new-businesses/${id}`);
          getSingleNewBusinesses(id);
        });
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  useEffect(() => {
    getNewBusinessesList();
    return () => {
      setModal({ isOpen: false });
    };
  }, []);

  const debouncedSearchTerm = useDebounce(formData, 500);

  const param = {
    q: formData.keyword,
    sort_by: 'asc',
  };

  useEffect(() => {
    if (debouncedSearchTerm && ordinanceRevisionId) {
      getNewBusinessesList({
        ordinance_revision_id: ordinanceRevisionId,
        q: formData.keyword,
        sort_by: 'desc',
      });
    } else {
      setFormData([]);
    }
  }, [debouncedSearchTerm, ordinanceRevisionId]);

  const handleOnChangeSelect = key => e => {
    setFilter({
      ...filter,
      [key]: e.value,
      kind_of_ownership: e.value,
    });
    getNewBusinessesList({ ...filter, kind_of_ownership: e.value });
  };

  const handleHoldOnHold = data => e => {
    e.preventDefault();

    ConfirmAlert(
      <div>
        Are you sure, do you want to{' '}
        {_.get(data, 'attributes.is_hold') ? 'Unhold' : 'Hold'} this business?
      </div>,
      hold_remarks => {
        holdBusiness(data.id, { hold_remarks }, () => {
          getSingleNewBusinesses(data.id);
        });
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      },
      true
    );
  };

  const handleOnRetireBusiness = data => e => {
    e.preventDefault();

    ConfirmAlert(
      <div>
        Are you sure, do you want to{' '}
        {_.get(data, 'attributes.is_retired') === 0 ? 'Retire' : 'Unretire'}{' '}
        this business?
      </div>,
      retire_remarks => {
        toggleBusinessRetirement(data.id, { retire_remarks }, () => {
          getSingleNewBusinesses(data.id);
        });
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      },
      true
    );
  };

  const handleOnRevertBusiness = data => e => {
    e.preventDefault();

    ConfirmAlert(
      <div>
        Are you sure, do you want to{' '}
        {_.get(data, 'attributes.is_retired') === 0 ? 'Retire' : 'Unretire'}{' '}
        this business?
      </div>,
      retire_remarks => {
        toggleBusinessRetirement(data.id, { retire_remarks }, () => {
          getSingleNewBusinesses(data.id);
        });
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      },
      true
    );
  };

  const handleLogs = data => e => {
    e.preventDefault();

    setModal({
      isOpen: true,
      content: <BusinessAuditLogs data={data} />,
      title: 'Business Logs',
      modalSize: 'modal-lg',
    });
  };

  const handleUpdateVeterinary = data => e => {
    e.preventDefault();

    setModal({
      isOpen: true,
      content: <UpdateVeterinaryModal data={data} id={data.id} />,
      title: 'Update Veterinary',
      modalSize: 'modal-md',
    });
  };

  const handleUpdateBaseLine = data => e => {
    e.preventDefault();

    setModal({
      isOpen: true,
      content: <UpdateBaseLineModal data={data} id={data.id} />,
      title: 'Update Base Line',
      modalSize: 'modal-md',
    });
  };

  return (
    <div className="card-content-listing m-0 p-0">
      <Route
        path={`${match.path}/:newBusinessesId?`}
        render={({ match: { params } }) => (
          <GenericListPair
            moduleName="Businesses"
            getData={getNewBusinessesList}
            setParams={param}
            setKeyword={handleOnChange}
            statusFilter
            statusOptions={c.KIND_OF_OWNERSHIP}
            setStatusFilter={handleOnChangeSelect(
              _.get(formData, 'kind_of_ownership')
            )}
            status={_.get(filter, 'kind_of_ownership') || ''}
            keyword={_.get(formData, 'keyword') || ''}
            keywordPlaceholder="Search..."
            pathName={`${match.path}/:newBusinessesId?`}
            listName="newBusinesses"
            label="Businesses"
            renderItem={item => (
              <div className="p-3 transaction-list-company">
                {_.get(item, 'attributes.business_name') || ''}
                <h4 className="mt-1 mb-0 transaction-list-name">
                  {_.get(item, 'attributes.bin')}
                </h4>
              </div>
            )}
            isLoading={isLoading}
            selected={params.newBusinessesId}
            data={newBusinessesList}
            dataPager={newBusinessesListPager}
            handleSelectRow={data => {
              history.push(`${match.url}/${_.get(data, 'id')}`);
            }}
            renderContent={() => (
              <React.Fragment>
                <Switch>
                  <Route
                    path={`${match.path}/:newBusinessesId?`}
                    render={() => (
                      <NewBusinessesContent
                        handleAddModal={handleAddModal}
                        handleAddTaxCredit={handleAddTaxCredit}
                        handleEdit={handleEdit}
                        handleRemove={handleRemove}
                        handleHoldOnHold={handleHoldOnHold}
                        handleOnRevertBusiness={handleOnRevertBusiness}
                        handleOnRetireBusiness={handleOnRetireBusiness}
                        ordinanceRevisionId={ordinanceRevisionId}
                        handleLogs={handleLogs}
                        handleUpdateVeterinary={handleUpdateVeterinary}
                        handleUpdateBaseLine={handleUpdateBaseLine}
                      />
                    )}
                  />
                </Switch>
                <Route
                  path={`${match.path}/:newBusinessesId?`}
                  render={() =>
                    !params.business_Id && newBusinessesList.length > 0 ? (
                      <Redirect
                        to={`${match.url}/${_.get(newBusinessesList, '0.id')}`}
                      />
                    ) : null
                  }
                />
              </React.Fragment>
            )}
          />
        )}
      />
    </div>
  );
}

NewBusinessesContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  getNewBusinessesList: PropTypes.instanceOf(Function).isRequired,
  newBusinessesList: PropTypes.instanceOf(Array).isRequired,
  newBusinessesListPager: PropTypes.instanceOf(Object).isRequired,
  removeNewBusinesses: PropTypes.instanceOf(Function).isRequired,
  isLoading: PropTypes.bool.isRequired,
  getSingleNewBusinesses: PropTypes.instanceOf(Function).isRequired,
  ordinanceRevisionId: PropTypes.number.isRequired,
  holdBusiness: PropTypes.instanceOf(Function).isRequired,

  toggleBusinessRetirement: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  newBusinessesList: _.get(api, `${c.GET_NEW_BUSINESSES}.list`) || [],
  newBusinessesListPager: _.get(api, `${c.GET_NEW_BUSINESSES}.pager`) || {},
  isLoading: _.get(api, 'loading', []).indexOf(c.GET_NEW_BUSINESSES) > -1,
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(NewBusinessesContainer);
